import { OwnBrand } from "../../utils/product/getOwnBrand";

const escapeRegexSpecialChars = (string: string) =>
  string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string

export function sanitiseTitle(
  title: string,
  ownBrand: OwnBrand,
  otherBrand?: string,
) {
  const isOwnBrand = !!ownBrand;
  if (isOwnBrand) {
    switch (ownBrand) {
      case "jl_own_brand_anyday_legacy":
        return title.replace(/^anyday/i, "").trim();
      case "jl_own_brand_anyday":
        return title.replace(/^john lewis anyday/i, "").trim();
      case "jl_own_brand_john_lewis":
        return title.replace(/^john lewis/i, "").trim();
      default:
        return title.trim();
    }
  } else if (otherBrand) {
    return title
      .replace(new RegExp(`^${escapeRegexSpecialChars(otherBrand)}`, "i"), "")
      .trim();
  } else {
    return title.trim();
  }
}
